module.exports = __webpack_public_path__ + "img/library_show_all_icon.85390db7.svg";